import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { IdentificationType } from "../../models/identification-type.model";
import { IdentificationTypeActions } from "./identification-type.actions";
import { IdentificationTypeService } from "../../services/identification-type.service";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";
import { tap } from "rxjs";

export class IdentificationTypeStateModel {
    public identificationTypes: IdentificationType[];
    public error: string;
  }

  const defaults = {
    identificationTypes: [],
    error: '',    
  };

  @State<IdentificationTypeStateModel>({
    name: 'identificationType',
    defaults,
  })
  @Injectable()
  export class IdentificationTypeState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      public store: Store,
      private identificationTypeService: IdentificationTypeService
    ) {}

    @Action(IdentificationTypeActions.GetIdentificationTypes) getIdentificationTypes(
      ctx: StateContext<IdentificationTypeStateModel>,
      {}: IdentificationTypeActions.GetIdentificationTypes
    ) {
      return this.identificationTypeService
        .getIdentificationTypes()
        .subscribe({
          next: (response) =>
            ctx.dispatch(new IdentificationTypeActions.GetIdentificationTypesSuccess(response)),
          error: (error) =>
            ctx.dispatch(new IdentificationTypeActions.GetIdentificationTypesFail(error)),
        });
    }

    @Action(IdentificationTypeActions.GetIdentificationTypesSuccess)
    getIdentificationTypesSuccess(ctx: StateContext<IdentificationTypeStateModel>,
      { identificationTypes }: IdentificationTypeActions.GetIdentificationTypesSuccess
    ) {
      ctx.patchState({
        identificationTypes: identificationTypes.sort((a, b) => a.name.localeCompare(b.name))
      });
    }

    @Action(IdentificationTypeActions.GetIdentificationTypesFail)
    getIdentificationTypesFailed(
      ctx: StateContext<IdentificationTypeStateModel>,
      { error }: IdentificationTypeActions.GetIdentificationTypesFail
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('labels.identificationType');
    }
  }
